import { use_slice_user } from '@/hooks/store/use_slices';
import { ENUM__user_role } from '@shared/dto/+user/entity/ENUM__user_role';
import { HARDWARE_STATS__fps } from './HARDWARE_STATS__fps';
import { HARDWARE_STATS__network_quality } from './HARDWARE_STATS__network_quality';
import { HARDWARE_STATS__ram } from './HARDWARE_STATS__ram';
import { HARDWARE_STATS__waiting_response } from './HARDWARE_STATS__waiting_response';

export function HARDWARE_STATS__master() {
  const { is_authorized, user_role } = use_slice_user(['is_authorized', 'user_role']);

  if (!is_authorized) return <></>;
  if (user_role != ENUM__user_role.ADMIN) return <></>;

  return (
    <div className=" flex flex-row flex-center flex-1 w-full border-t border-component-border">
      <HARDWARE_STATS__fps />
      <HARDWARE_STATS__ram />
      <HARDWARE_STATS__network_quality />
      <HARDWARE_STATS__waiting_response />
    </div>
  );
}
